import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { products } from 'src/app/core/data-models/company-permission';
import { EssentialObjectService } from 'src/app/core/services/essential-object.service';
import { GeneralService } from 'src/app/core/services/general.service';
import { LocalService } from 'src/app/core/services/local.service';
import { PlatformUserService } from 'src/app/core/services/platform-user.service';
import { ProductPermissionGuard } from 'src/app/core/services/product-permission.guard';

/**
 * Gates /accountoverview on the Overview permission.
 *
 * The page is about unit balances for the tenant and its companies, so Overview is
 * the permission that maps to it — see GeneralService.resolveRoute, which routes
 * products.Overview here. It previously checked products.Exit, inherited from the
 * exit list component it was copied from.
 */
@Injectable({ providedIn: 'root' })
export class AccountOverviewPermissionGuard extends ProductPermissionGuard {

  protected get product(): products {
    return products.Overview;
  }

  constructor(platformUserService: PlatformUserService, essentialObjectService: EssentialObjectService,
    generalService: GeneralService, localService: LocalService, router: Router) {
    super(platformUserService, essentialObjectService, generalService, localService, router);
  }
}
